<div class="title"
    (click)="toggleExpanded()">
    <span class="text">{{panelTitle}}</span>
    <span class="sign">{{ expanded ? '-' : '+' }}</span>
</div>
<div class="body">
    <ng-content></ng-content>
</div>